import _ from 'lodash'
import i18NextInstance from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en-GB'
import it from './it-IT'
import { Dictionary } from '../utils/types'

const isDebug = process.env.NODE_ENV === 'development'

export const availableLanguages: Dictionary<string> = {
  'en-GB': 'EN',
  'it-IT': 'IT'
}

const config = {
  resources: {
    'en-GB': en,
    'it-IT': it
  },
  isDebug,
  lng: 'it-IT',
  fallbackLng: 'it-IT',
  keySeparator: '.',
  interpolation: {
    escapeValue: false
  },
  saveMissing: isDebug,
  missingKeyHandler: (lngs: string[], ns: string, key: string) => {
    const message = `Translation for key: ${ns}:${key} is missing in languages: ${_.join(lngs, ',')}`
    if (isDebug) {
      throw new Error(message)
    } else {
      console.warn(message) // eslint-disable-line no-console
    }
  }
}

i18NextInstance.use(initReactI18next).init(config)

export const i18n = i18NextInstance
